module.exports = __webpack_public_path__ + "img/antes_despues_115.336668c5.png";